<template>
  <b-container>
    <b-row style="margin-top: 5em">
      <b-col>
        <h2 class="text-secondary">
          {{ $t("globals.all_customers") + " " }}
          <v-icon v-if="getAllCustomersLoading" name="spinner" spin></v-icon>
        </h2>
      </b-col>
      <b-col>
        <b-btn
          class="float-right m-1"
          @click="csvExportModal.show = true"
          v-b-tooltip.hover
          :title=" $t('globals.download_csv')"
        >
          <v-icon name="file-download"></v-icon>
        </b-btn>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="my-3">
        <b-input-group>
          <b-form-input
            v-model="filter"
            :placeholder="$t('globals.type_to_search')"
          />
          <b-input-group-append>
            <b-btn variant="warning" :disabled="!filter" @click="filter = ''">
              {{ $t("globals.clear") }}
            </b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col cols="2" class="my-3">
        <b-form-select v-model="perPage" :options="perPageOptions" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          hover
          small
          primary-key="id"
          :filter="filter"
          :current-page="currentPage"
          :per-page="perPage"
          :items="getAllCustomers"
          :fields="fields"
          @row-clicked="rowClicked"
          @filtered="onFiltered"
        >
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="my-1">
        <b-pagination
          :total-rows="getAllCustomers.length"
          :per-page="perPage"
          v-model="currentPage"
        />
      </b-col>
    </b-row>
    <export-csv-modal :show="csvExportModal.show" :close="closeModals"/>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    "export-csv-modal": () =>
      import("@/components/customers/all_customers/ExportCsvModal.vue")
  },
  data() {
    return {
      csvExportModal: {
        show: false
      },
      filter: null,
      currentPage: 1,
      perPage: 20,
      perPageOptions: [
        { text: "20 " + this.$t("globals.per_page"), value: 20 },
        { text: "40 " + this.$t("globals.per_page"), value: 40 },
        { text: "60 " + this.$t("globals.per_page"), value: 60 }
      ],
      fields: [
        {
          key: "id",
          sortable: true
        },
        {
          key: "company_name",
          label: this.$t("globals.name"),
          sortable: true
        },
        {
          key: "no_devices",
          label: this.$t("globals.number_of_devices"),
          sortable: true
        },
        {
          key: "web_app_id",
          sortable: true
        },
        {
          key: "debiteur_no",
          label: this.$t("globals.debiteur_no"),
          sortable: true
        }
      ]
    };
  },
  computed: {
    ...mapGetters("customers", ["getAllCustomers", "getAllCustomersLoading"])
  },
  methods: {
    ...mapActions("customers", ["fetchAllCustomers"]),
    rowClicked(item) {
      this.$router.push({ name: "customer", params: { id: item.id } });
    },
    closeModals() {
      this.csvExportModal.show = false;
      this.fetchAllCustomers();
    },
    onFiltered() {
      this.currentPage = 1;
    }
  },
  mounted() {
    this.fetchAllCustomers();
  }
};
</script>
